export default __webpack_public_path__ + "static/media/avatar_02.be30c637.jpg";